import React, { FC, ReactNode } from 'react';

interface MarketingPageLayoutProps {
  header: ReactNode;
  body: ReactNode;
}
const MarketingPageLayout: FC<MarketingPageLayoutProps> = ({ header, body }) => (
  <div id="marketing-page-layout">
    <header id="page-header">{header}</header>
    <div className="marketing-page-container">
      <main id="page-body">
        <section id="document">{body}</section>
      </main>
    </div>
  </div>
);

export default MarketingPageLayout;
